module.exports = {
  Datasets: [
    {
      title: 'ATC',
      label: 'ATC',
      description: '15 minutes volume and speed bin data',
      datasetLink: `https://usmart.ai/organisation/centralbedfordshire/dataset/e29ea16b-fc06-4e7d-adb6-6c7cce883a00`,
      datasetGUID: 'e29ea16b-fc06-4e7d-adb6-6c7cce883a00',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/c03ae199-a5cf-4fc2-b1ca-fb065e3f368e/latest/urql',
      availableReports: ['Speed Reports', 'Multiday Volume Reports'],
      index: '4099133d-fcf9-4386-a122-d994abd02e29',
      VehicleReport: '',
      SpeedReports: 'atc_speed_reports:generate',
      MultidayVolumeReports: 'atc_multiday_volume_reports:generate',
      MultidaySpeedReports: '',
      comparisonReports: {
        SpeedReports: 'atc_comparison_speed_report:generate',
        VehicleReport: '',
        MultidayVolumeReports: 'atc_comparison_multiday_volume:generate',
        MultidaySpeedReports: '',
      },
      siteIDField: 'Site',
      primaryDateField: 'Timestamp',
      type: 'default',
    },
    {
      title: 'DFT',
      label: 'DFT',
      description:
        'Department for Transport hourly volume data by vehicle type',
      datasetLink: `https://usmart.ai/org/centralbedfordshire/dataset/view-edit?datasetGUID=f7e6e9d2-2271-4d82-a586-1df584361ad5`,
      datasetGUID: '9c206340-bb2e-466d-8433-266ab01f387f',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/9c206340-bb2e-466d-8433-266ab01f387f/latest/urql',
      availableReports: ['Vehicle Report', 'Multiday Volume Reports'],
      index: 'e1cb6938-fe10-43f1-96e6-6bf638873eea',
      VehicleReport: 'cb_dft_vehicle_report:generate',
      SpeedReports: '',
      MultidayVolumeReports: 'cb_dft_multiday_volume_reports:generate',
      MultidaySpeedReports: '',
      comparisonReports: {
        SpeedReports: '',
        VehicleReport: 'cb_dft_comparison_vehicle_report:generate',
        MultidayVolumeReports:
          'cb_dft_comparison_multiday_volume_reports:generate',
        MultidaySpeedReports: '',
      },
      siteIDField: 'count_point_id',
      primaryDateField: 'timestamp',
      type: 'default',
    },
    {
      title: 'CBC_PERMANENT',
      description:
        '1989 - 2018 hourly data volume and in some cases classified by length',
      label: 'Historic PERMANENT',
      datasetLink: `https://usmart.ai/org/centralbedfordshire/dataset/view-edit?datasetGUID=73347f78-ae8f-46b1-be2f-bcc099058514`,
      datasetGUID: '2f6818c6-e3e4-4b19-af10-08ace2296860',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/2f6818c6-e3e4-4b19-af10-08ace2296860/latest/urql',
      availableReports: [
        'Vehicle Report',
        'Speed Reports',
        'Multiday Speed Reports',
        'Length Reports',
      ],
      index: '15c3b2c9-7aa3-443d-b736-c72df9d9dd01',
      siteIDField: 'site',
      primaryDateField: 'timestamp',
      type: 'new',
      reportUrl: `${process.env.VUE_APP_REPORT_URL}bedfordshire_reports:generate`,
    },
    {
      title: 'CBC_RADAR',
      description: '2000 to 2015 data from speed and length bins',
      label: 'Historic Radar',
      datasetLink: `https://usmart.ai/org/centralbedfordshire/dataset/view-edit?datasetGUID=6c22b48e-6830-4a8c-a18c-6792832e20af`,
      datasetGUID: '6c22b48e-6830-4a8c-a18c-6792832e20af',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/7555c1dd-90e2-4f55-9ab0-a853c311f5e6/latest/urql',
      availableReports: [
        'Length Reports',
        'Speed Reports',
        'Multiday Speed Reports',
        'Volume Report',
      ],
      index: 'e8426bc6-5394-43c7-bc1d-08d9c197538d',
      siteIDField: 'site',
      primaryDateField: 'timestamp',
      type: 'new',
      reportUrl: `${process.env.VUE_APP_REPORT_URL}bedfordshire_reports:generate`,
    },
    {
      title: 'CBC_INDIVIDUAL',
      description: '2008 - 2015 data from speed bins',
      label: 'Historic Individual',
      datasetLink: `https://usmart.ai/org/centralbedfordshire/dataset/view-edit?datasetGUID=fb3650c6-f7e8-4a34-8dad-a31cd539f6b4`,
      datasetGUID: 'fb3650c6-f7e8-4a34-8dad-a31cd539f6b4',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/e47505bf-2417-4da1-9c72-904196388336/latest/urql',
      availableReports: [
        'Vehicle Report',
        'Speed Reports',
        'Multiday Speed Reports',
        'Length Reports',
      ],
      index: '25f66411-d93d-4dcd-b4f5-b5444192705c',
      siteIDField: 'site',
      primaryDateField: 'timestamp',
      type: 'new',
      reportUrl: `${process.env.VUE_APP_REPORT_URL}bedfordshire_reports:generate`,
    },
    {
      title: 'CBC_TARA',
      label: 'CBC TARA',
      description:
        '1985 - 2009 data for hourly volume and vehicle classification (when recorded) by site.',
      datasetLink: `https://usmart.ai/org/centralbedfordshire/dataset/view-edit?datasetGUID=8b782113-648d-426d-b898-a6e13a42564c`,
      datasetGUID: '1cb87c12-eff8-45e1-9782-06479f14489d',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/1cb87c12-eff8-45e1-9782-06479f14489d/latest/urql',
      availableReports: [
        'Vehicle Report',
        'Multiday Speed Reports',
        'Speed Reports',
        'Length Reports',
      ],
      index: 'e41eedd2-b3f4-48de-b532-3e7a46ac19ae',
      siteIDField: 'site',
      primaryDateField: 'timestamp',
      type: 'new',
      reportUrl: `${process.env.VUE_APP_REPORT_URL}bedfordshire_reports:generate`,
    },
    {
      title: 'CBC_CYCLES',
      label: 'CBC CYCLES',
      description: '2000 - 2017 data for hourly cycle count locations',
      datasetLink: `https://usmart.ai/org/centralbedfordshire/dataset/view-edit?datasetGUID=b6183d3b-56da-4705-b2c7-272b54f8faeb`,
      datasetGUID: 'ab871125-674d-432c-af1e-d7846a41728a',
      apiResource:
        'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/ab871125-674d-432c-af1e-d7846a41728a/latest/urql',
      availableReports: ['Volume Report'],
      index: '8a1338f5-00dc-4fae-bd42-225ac2bfb1b8',
      siteIDField: 'site',
      primaryDateField: 'timestamp',
      type: 'new',
      reportUrl: `${process.env.VUE_APP_REPORT_URL}bedfordshire_reports:generate`,
    },
    // {
    //   title: 'HISTORIC',
    //   datasetLink: ``,
    //   datasetGUID: '',
    //   apiResource: '',
    //   availableReports: [
    //     'Vehicle Report',
    //     'Multiday Volume Reports',
    //     'Speed Reports',
    //     'Length Reports',
    //   ],
    //   index: '',
    //   siteIDField: 'site',
    //   primaryDateField: 'timestamp',
    //   type: 'new',
    //   reportUrl: `${process.env.VUE_APP_REPORT_URL}bedfordshire_reports:generate`,
    // },
  ],
  allSitesAPI:
    'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/68d3adcf-4c8b-4d95-a16e-1324e1835ef5/latest/urql',
  siteSummaryAPI:
    'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/d7d33134-e468-4258-925f-d11a66ce103e/latest/urql',
  summaryDatasetAPI:
    'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/43d21f1e-cf50-41be-95d8-7fdbfc76c6bd/latest/urql',
  siteGroupingsAPI:
    'https://api.usmart.ai/org/1f7501d4-3459-4c85-be3d-5ed23b68a205/fcd57460-c25c-4a0d-b475-9e713d0be1a0/latest/urql',
  newReportsMapping: {
    SpeedReports: 'speed',
    MultidaySpeedReports: 'multi-day-speed',
    VehicleReport: 'vehicle',
    LengthReports: 'length',
    VolumeReport: 'volume',
  },
};
